
// ---- Ghost Admin Components ----
// Handles staff-only UI elements: Edit/Admin buttons and the Public/Member View toggle.
// Activated only when the `ghost-admin-components-enabled=1` cookie is set by upstream Caddy.
// Desktop only (>= 768px).

document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth < 768) return;

    const editBtn = document.getElementById('psa-edit-btn');
    const adminBtn = document.getElementById('psa-admin-btn');
    const publicToggleBtn = document.getElementById('psa-public-toggle');
    if (!editBtn && !adminBtn && !publicToggleBtn) return;

    // Fast, zero-latency synchronous check for a non-HttpOnly flag cookie set by upstream Caddy
    if (!document.cookie.includes('ghost-admin-components-enabled=1')) return;

    const isPostOrPage = document.body.classList.contains('post-template') || document.body.classList.contains('page-template');

    if (isPostOrPage) {
        // Standard Ghost behavior: /edit suffix on any post redirects to the editor
        if (editBtn) {
            editBtn.href = window.location.href.replace(/\/$/, '') + '/edit';
            editBtn.classList.remove('hidden');
            editBtn.classList.add('flex');
        }

        if (publicToggleBtn) {
            publicToggleBtn.classList.remove('hidden');
            publicToggleBtn.classList.add('flex');

            // If the real paywall section is present, the user is already viewing public content.
            // Disable the toggle - it has no further effect.
            if (document.getElementById('psaintelligence-paywall')) {
                // Already in public state — disable interaction and revert to muted gray style
                publicToggleBtn.classList.remove('text-psa-orange', 'border-psa-orange', 'hover-elevate', 'cursor-pointer');
                publicToggleBtn.classList.add('text-gray-400', 'border-gray-200', 'bg-gray-50');
                publicToggleBtn.style.cursor = 'not-allowed';
                publicToggleBtn.setAttribute('title', 'Content is paywalled - viewing in public state');
            } else {
                publicToggleBtn.addEventListener('click', () => {
                    const contentSection = document.querySelector('section.gh-content');
                    if (!contentSection) return;

                    const state = publicToggleBtn.getAttribute('data-state');

                    if (state === 'off') {
                        // Activating: switching to Public View simulation (hiding member content)
                        publicToggleBtn.setAttribute('data-state', 'on');
                        publicToggleBtn.classList.add('bg-psa-orange', 'text-white');
                        publicToggleBtn.classList.remove('text-psa-orange', 'hover-elevate');

                        // Find <!--members-only--> comment and hide everything after it
                        let foundMembersOnly = false;
                        let hasHiddenPartial = false;
                        contentSection.childNodes.forEach(node => {
                            if (node.nodeType === 8 && node.nodeValue.trim() === 'members-only') {
                                foundMembersOnly = true;
                            } else if (foundMembersOnly && node.nodeType === 1) {
                                node.setAttribute('data-psa-hidden', node.style.display || 'none-default');
                                node.style.display = 'none';
                                hasHiddenPartial = true;
                            }
                        });

                        // If no <!--members-only--> comment found, hide the whole section content
                        if (!hasHiddenPartial) {
                            contentSection.childNodes.forEach(node => {
                                if (node.nodeType === 1) {
                                    node.setAttribute('data-psa-hidden', node.style.display || 'none-default');
                                    node.style.display = 'none';
                                }
                            });
                        }

                        // Inject faux paywall indicator
                        if (!document.getElementById('psa-faux-paywall')) {
                            const faux = document.createElement('div');
                            faux.id = 'psa-faux-paywall';
                            faux.className = 'my-12 rounded-lg border border-psa-navy-border bg-psa-navy-light p-8 text-center';
                            faux.innerHTML = `
                                <div class="mx-auto max-w-sm">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto mb-4 h-10 w-10 text-psa-blue">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                                    </svg>
                                    <h2 class="text-xl font-bold text-gray-900">Paywall Goes Here</h2>
                                    <p class="mt-2 text-[14px] text-gray-500 leading-relaxed">This is the location of the members content paywall.</p>
                                </div>
                            `;
                            contentSection.appendChild(faux);
                        }

                    } else {
                        // Deactivating: returning to full Member View (restore all content)
                        publicToggleBtn.setAttribute('data-state', 'off');
                        publicToggleBtn.classList.remove('bg-psa-orange', 'text-white');
                        publicToggleBtn.classList.add('text-psa-orange', 'hover-elevate');

                        // Remove the faux paywall block
                        const pw = document.getElementById('psa-faux-paywall');
                        if (pw) pw.remove();

                        // Restore all hidden nodes
                        contentSection.childNodes.forEach(node => {
                            if (node.nodeType === 1 && node.hasAttribute('data-psa-hidden')) {
                                const orig = node.getAttribute('data-psa-hidden');
                                node.style.display = orig === 'none-default' ? '' : orig;
                                node.removeAttribute('data-psa-hidden');
                            }
                        });
                    }
                });
            }
        }

    } else {
        // On index / tag / author pages — show Admin button only
        if (adminBtn) {
            adminBtn.classList.remove('hidden');
            adminBtn.classList.add('flex');
        }
    }
});
